'use client';

import { Fragment } from 'react';
import Link from 'next/link';
import party from 'party-js';

export function triggerConfetti(e) {
    party.confetti(e.target, {
        count: party.variation.range(20, 40),
    });
}

const Frappe = () => {
    return (
        <Fragment>
            <p>
                <i
                    onMouseOver={triggerConfetti}
                    className="ri-trophy-fill text-yellow-300 text-2xl mx-2"
                ></i>
                <Link
                    rel="canonical"
                    target="_blank"
                    href="https://frappe.io/partners/all/Wahni%20IT%20Solutions"
                    className="text-lg text-gray-600"
                >
                    Frappe Certified Silver Partner
                </Link>
            </p>
        </Fragment>
    );
};

export default Frappe;
